import React, { useEffect, useState } from 'react';

import { fetchInstagramEngagment } from '../../services/group';
import { Card, Spin } from 'antd';

const PostEngagementDetails = ({ elem }) => {





  return (

    <table className="post_details table-auto w-full text-left border-collapse mt-2">
        {elem.platform=='facebook' &&
      <tbody>
         <tr>
          <td className="font-semibold py-2">Public Engagements</td>
          <td>
           
              {elem?.likes?.summary.total_count +
              elem?.comments?.summary.total_count}
        
          </td>
          </tr>
          <tr>
                      <td className="font-semibold py-2">Post Impression</td>
          <td>
            {elem?.insights?.post_impressions}
          </td>
        </tr>
        <tr>
                      <td className="font-semibold py-2">Post Clicks</td>
          <td>
            {elem?.insights?.post_clicks}
          </td>
        </tr>
        <tr>
                      <td className="font-semibold py-2">Comments</td>
          <td>
            {elem?.comments?.summary.total_count}
          </td>
        </tr>
        <tr>
                      <td className="font-semibold py-2">Likes</td>
          <td>
            {elem?.likes?.summary.total_count}
          </td>
       
        </tr>
        </tbody>
        }
         {elem.platform=='instagram' &&
      <tbody>
         <tr>
          <td className="font-semibold py-2">Public Engagements</td>
          <td>
           
        { (elem?.like_count + elem?.comments_count)}
        
          </td>
            </tr>
          <tr>
                      <td className="font-semibold py-2">Reach</td>
          <td>
          {elem?.insights?.find(item=>item.name=='reach')?.values[0]?.value}
          </td>
        </tr>
        <tr>
                      <td className="font-semibold py-2">Saved</td>
          <td>
          {elem?.insights?.find(item=>item.name=='saved')?.values[0]?.value}
          </td>
        </tr>
        <tr>
                      <td className="font-semibold py-2">Total Interaction</td>
          <td>
          {elem?.insights?.find(item=>item.name=='total_interactions')?.values[0]?.value}
          </td>
        </tr>
        <tr>
                      <td className="font-semibold py-2">Share</td>
          <td>
            {elem?.insights?.find(item=>item.name=='shares')?.values[0]?.value}
          </td>
        </tr>
        <tr>
                      <td className="font-semibold py-2">Comments</td>
          <td>
            {elem?.comments_count}
          </td>
        </tr>
        <tr>
                      <td className="font-semibold py-2">Likes</td>
          <td>
            {elem?.like_count}
          </td>
        </tr>
       
        </tbody>
        }
     
     {elem.platform=='pinterest' &&
      <tbody>
         <tr>
          <td className="font-semibold py-2">Public Engagements</td>
          <td>
           
        N/A
        
          </td>
          </tr>
          <tr>
                      <td className="font-semibold py-2">Reach</td>
          <td>
          N/A
          </td>
        </tr>
        <tr>
                      <td className="font-semibold py-2">Saved</td>
          <td>
          N/A
          </td>
        </tr>
        <tr>
                      <td className="font-semibold py-2">Total Interaction</td>
          <td>
          N/A
          </td>
        </tr>
        <tr>
                      <td className="font-semibold py-2">Share</td>
          <td>
          N/A
          </td>
        </tr>
        <tr>
                      <td className="font-semibold py-2">Comments</td>
          <td>
          N/A
          </td>
        </tr>
        <tr>
                      <td className="font-semibold py-2">Likes</td>
          <td>
          N/A
          </td>
        </tr>
        
        </tbody>
        }
    </table>
  );
};

export default PostEngagementDetails;
   {/* <tr>
          <td className="font-semibold py-2">Public Engagements</td>
          <td>
            {elem?.platform === 'instagram' &&
              (elem?.comments_count + elem?.comments_count)}
            {elem?.platform === 'facebook' &&
              elem?.likes?.summary.total_count +
              elem?.comments?.summary.total_count}
            {elem?.platform === 'pinterest' && 'NA'}
          </td>
        </tr>
        <tr>
          <td className="font-semibold py-2">Reach</td>
          <td>
            {elem?.platform === 'instagram' &&
              (elem?.comments_count + elem?.comments_count)}
            {elem?.platform === 'facebook' &&
              elem?.insights?.find(item=>item.name=='reach')?.values?.value ||0
              
              }
            {elem?.platform === 'pinterest' && 'NA'}
          </td>
        </tr>
        <tr>
          <td className="font-semibold py-2">Share</td>
          <td>
            {elem?.platform === 'instagram' &&
              (elem?.comments_count + elem?.comments_count)}
            {elem?.platform === 'facebook' &&
              elem?.insights?.find(item=>item.name=='shares')?.values?.value ||0
              
              }
              {console.log(elem,'hiih')}
            {elem?.platform === 'pinterest' && 'NA'}
          </td>
        </tr>
        <tr>
          <td className="font-semibold py-2">Likes</td>
          <td>
            {elem?.platform === 'instagram' && elem?.likes}
            {elem?.platform === 'facebook' &&
              elem?.likes?.summary.total_count}
            {elem?.platform === 'pinterest' && 'NA'}
          </td>
        </tr>
        <tr>
          <td className="font-semibold py-2">Comments</td>
          <td>
            {elem?.platform === 'instagram' && elem?.comments}
            {elem?.platform === 'facebook' &&
              elem?.comments?.summary.total_count}
            {elem?.platform === 'pinterest' && 'NA'}
          </td>
        </tr>
      </tbody> */}